;(function ($) {
  var Accordion = function (element, options) {
    this.options = options
    this.$element = $(element)
    this.$toggleContainer = this.$element.find(options.toggleContainer)
    this.$toggleButton = this.$element.find(options.toggleButton)
    this.$closeButton = this.$element.find(options.closeButton)
    this.init()
  }

  Accordion.defaults = {
    toggleClass: '.accordion-header',
    toggleContainer: '.accordion-container',
    toggleButton: '.accordion-header',
    closeButton: '.accordion-close',
    singleOpen: true
  }

  Accordion.last = null

  Accordion.prototype.init = function () {
    var _this = this
    if (Accordion.last === null) Accordion.last = this

    // Set init attr
    this.$element.attr('data-accordion', '')

    // Toggle if url hash is pointing to this accordion
    if (this.$element.attr('id') === location.hash.replace('#', '')) {
      this.$element.addClass(this.options.toggleClass)
    }

    // Toggle Button
    this.$toggleButton.click(function () {
      _this.toggle()
    })
    // Close Button
    this.$closeButton.click(function () {
      _this.close()
    })
  }

  Accordion.prototype.toggle = function () {
    if (this.options.singleOpen && Accordion.last !== this) {
      Accordion.last.close()
      Accordion.last = this
    }
    this.$element.toggleClass(this.options.toggleClass)
    if (this.$element.hasClass(this.options.toggleClass)) {
      this.$toggleContainer.slideDown(300)
    } else {
      this.$toggleContainer.slideUp(300)
    }
  }

  Accordion.prototype.close = function () {
    this.$element.removeClass(this.options.toggleClass)
    this.$toggleContainer.slideUp(300)
  }

  $.fn.Accordion = function (option) {
    return this.each(function () {
      var $this = $(this)
      var data = $this.data('Accordion')
      var options = $.extend(
        {},
        Accordion.defaults,
        $this.data(),
        typeof option == 'object' && option
      )
      if (!data) {
        $this.data('Accordion', (data = new Accordion(this, options)))
      }
    })
  }
})(jQuery)
